import React from 'react';
import { useTranslation } from 'react-i18next';
import parameters from '../../config/profile';
import OptionRow from './OptionRow';
import Header from '../Units/Header'
import gitVersion from '../../_git_commit';

const gitInfo = gitVersion.logMessage ? gitVersion.logMessage : 'xxx';

const About = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Header title='aboutTitle' backTo={'/profile'} />
            <div className={`profileTutorial`}>
                {
                    parameters['about'].map((option, index) => <OptionRow key={index} option={option} section="about"></OptionRow>)
                }
                <div className={`optionRow version`}>{`${t('version')}: ${gitInfo}`}</div>
            </div>
        </React.Fragment>
    )
}
export default About;